import HallowButton from "../../components/customComponents/HallowButton";
import ContactInformationModal from "../../components/Modal/ContactInformationModal";
import { useDispatch, useSelector } from "react-redux";
import { setContactInformationModal } from "../../reducer/modalReducer";
import { RootState } from "../../app/store";
import { useEffect, useState } from "react";

export default function RegistrationContactInformationSection() {
  const dispatch = useDispatch();
  const {
    streetAddress,
    city,
    postalCode,
    stateRegion,
    phoneNumber,
    countryCode,
    firstName,
    lastName,
  } = useSelector((state: RootState) => state.registration);

  const profile = useSelector((state: RootState) => state.profile.profile);

  const [editedStreetAddress, setEditedStreetAddress] = useState<string>("");
  const [editedCity, setEditedCity] = useState<string>("");
  const [editedPostalCode, setEditedPostalCode] = useState<string>("");
  const [editedStateRegion, setEditedStateRegion] = useState<string>("");
  const [editedPhoneNumber, setEditedPhoneNumber] = useState<string>("");
  const [editedCountryCode, setEditedCountryCode] = useState<string>("");
  const [editedFirstName, setEditedFirstName] = useState<string>("");
  const [editedLastName, setEditedLastName] = useState<string>("");

  useEffect(() => {
    if (profile) {
      setEditedStreetAddress(profile.mainAddress || streetAddress);
      setEditedCity(profile.locations[0] || city);
      setEditedPostalCode(profile.locations[1] || postalCode);
      setEditedStateRegion(profile.locations[2] || stateRegion);
      setEditedPhoneNumber(profile.contactPhoneNumber || phoneNumber);
      setEditedCountryCode(profile.countryCode || countryCode);
      setEditedFirstName(profile.firstName || firstName || "");
      setEditedLastName(profile.lastName || lastName || "");
    }
  }, [profile]);

  const handleEditButtonClick = () => {
    dispatch(setContactInformationModal(true));
  };

  return (
    <div className={Classname.container}>
      <ContactInformationModal />
      <div className={Classname.flexBetween}>
        <div className="font-semibold mb-3">Contact Information</div>
        <HallowButton label="Edit" onClick={handleEditButtonClick} />
      </div>

      <div className={Classname.listContainer}>
        <div className={Classname.title}>Phone number</div>
        {editedPhoneNumber ? (
          <div>+{editedPhoneNumber}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
      <div className={Classname.listContainer}>
        <div className={Classname.title}>Street address</div>
        {editedStreetAddress ? (
          <div>{editedStreetAddress}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
      <div className={Classname.listContainer}>
        <div className={Classname.title}>City</div>
        {editedCity ? (
          <div>{editedCity}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
      <div className={Classname.listContainer}>
        <div className={Classname.title}>Postal code</div>
        {editedPostalCode ? (
          <div>{editedPostalCode}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
      <div className={Classname.listContainer}>
        <div className={Classname.title}>State/Region</div>
        {editedStateRegion ? (
          <div>{editedStateRegion}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
      <div className={Classname.listContainer}>
        <div className={Classname.title}>Full name</div>
        {editedFirstName || editedLastName ? (
          <div>{`${editedFirstName} ${editedLastName}`.trim()}</div>
        ) : (
          <span className={Classname.unspecified}>Unspecified</span>
        )}
      </div>
    </div>
  );
}

const Classname = {
  container: "bg-white pb-10 rounded-md p-2 h-fit gap-3 flex flex-col lg:px-10",
  flexBetween: "flex justify-between mt-5",
  title: "font-bold w-48 mb-4",
  listContainer: "flex lg:gap-40 flex-col lg:flex-row",
  unspecified: "text-red-500 ",
};
